<template>
  <oceano-default-section :section="section" :menu="menu"
                          class="menu--section-oceano_two_column menu--section-two_column"></oceano-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Oceano two column menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoTwoColumnSection> adds a two column layout for Oceano menu sections.
 *
 *  2025-04-08 (1.0.1) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <OceanoTwoColumnSection>.
 *    - Remove "visual_" prefix from class names in <OceanoTwoColumnSection>.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoTwoColumnSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-oceano_two_column:not(.menu--section-show_bin):deep(.menu--item:not(.menu--item-price_header) .menu--item_description) {
  grid-column: 1 / 3;
}

.menu--section-oceano_two_column:not(.menu--section-show_bin):deep(.menu--item:not(.menu--item-price_header) .menu--item_price) {
  grid-row: 1;
}
</style>